import * as React from 'react';

import { ProductCardPlaceholder } from '@notino/react-styleguide';

import { useFeatureFlags } from '@context/featureFlags/FeatureFlagsProvider';

import {
  StyledCardPlaceholderItem,
  StyledCardPlaceholderList,
  StyledListPlaceholder,
} from './styled';

interface IProductsSectionPlaceholderProps {
  itemsPerSlide: number;
  listLabel?: string;
  rows?: number;
  centerPlaceholder?: boolean;
}

export const ProductsSectionPlaceholder: React.FC<
  IProductsSectionPlaceholderProps
> = ({ itemsPerSlide, listLabel = '', rows = 4, centerPlaceholder }) => {
  const { release_discovery_product_card_2026 } = useFeatureFlags();

  if (!release_discovery_product_card_2026) {
    return (
      <StyledListPlaceholder
        id={listLabel}
        placeholderCount={itemsPerSlide}
        rows={rows}
        center={centerPlaceholder}
        containerProps={{
          ['data-testid']: 'product-items-placeholder',
        }}
      />
    );
  }

  return (
    <StyledCardPlaceholderList
      id={listLabel}
      data-testid="product-items-placeholder"
    >
      {Array.from({ length: itemsPerSlide }, (_, index) => (
        <StyledCardPlaceholderItem
          key={`product-card-placeholder-${index}`}
          data-testid="product-item-placeholder"
        >
          <ProductCardPlaceholder rows={rows} />
        </StyledCardPlaceholderItem>
      ))}
    </StyledCardPlaceholderList>
  );
};
